
import { Component, Vue, Prop } from 'vue-property-decorator';
import { ExportReceiptModel } from '@/models/export-receipt';
import { DATA } from '@/config/data';
@Component
export default class AmountDetail extends Vue {
    @Prop({default: null})
    private exportReceipt!: ExportReceiptModel;

    get feeTypes() {
        return DATA.feeTypes;
    }
}
